import { jsx as _jsx } from "react/jsx-runtime";
import { getTiposNaturezasCrimes } from './tipos_naturezas_crimes_service';
import { ROUTES, PAGINAS, FUNCIONALIDADES } from '../../../routes';
import GridBase from '../../../components/grid_base';
var COLUNAS = [
    { field: 'nome', headerName: 'Nome', width: 500 },
    { field: 'situacao', headerName: 'Situação', width: 150 },
];
export function TiposNaturezasCrimesListar() {
    return (_jsx(GridBase, { pagina: PAGINAS.TIPOS_NATUREZAS_CRIMES, paginaPermissao: FUNCIONALIDADES.TIPOS_NATUREZAS_CRIMES, rota: ROUTES.TIPOS_NATUREZAS_CRIMES, fetchData: function (str, _filter, pag) { return getTiposNaturezasCrimes(str, pag); }, columns: COLUNAS }));
}
export default TiposNaturezasCrimesListar;
